import React from 'react';

import { ReferenceField, TextField, useRecordContext } from 'react-admin';

import { get } from 'lodash';

import DiffFieldLayout from './DiffFieldLayout';

const ReferenceDiffField = ({
  source,
  label,
  reference,
  optionText = 'name',
  hasLink = true,
  children,
}: {
  source: string;
  label: string;
  reference: string;
  optionText?: string;
  hasLink?: boolean;
  children?: React.ReactNode;
}) => {
  const record = useRecordContext();

  const oldValue = get(record, `${source}.oldRawValue`);
  const newValue = get(record, `${source}.newRawValue`);

  const referenceChildren = children ?? <TextField source={optionText} />;

  return (
    <DiffFieldLayout
      label={label}
      oldElement={(
        <ReferenceField
          record={{ value: oldValue }}
          source="value"
          reference={reference}
          empty="-"
          link={hasLink ? 'edit' : false}
        >
          {referenceChildren}
        </ReferenceField>
      )}
      newElement={(
        <ReferenceField
          record={{ value: newValue }}
          source="value"
          reference={reference}
          empty="-"
          link={hasLink ? 'edit' : false}
        >
          {referenceChildren}
        </ReferenceField>
      )}
    />
  );
};

export default ReferenceDiffField;
